<template>
  <div>
    <topsearch title="Admin" />

    <div class="flex">
      <div class="w-72 border-r h-full">
        <adminSidebar />
      </div>
      <div class="w-full md:p-4">
        <!-- Features -->
        <!-- Grid -->
        <div class="grid  grid-cols-2  ">
          <!-- Stats -->
          <div>
            <h4
              class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
            >
              Kullanıcı Sayısı
            </h4>
            <p
              class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600"
            >
              {{ data.users.count }}
            </p>
          </div>
          <!-- End Stats -->

          <!-- Stats -->
          <div>
            <h4
              class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
            >
              Müşteri Adaylari Sayısı
            </h4>
            <p
              class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600"
            >
              {{ data.leads.count }}
            </p>
          </div>
          <!-- End Stats -->

          <!-- Stats -->
          <div>
            <h4
              class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
            >
              Müşteri Sayısı
            </h4>
            <p
              class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600"
            >
              {{ data.customers.count }}
            </p>
          </div>
          <div>
            <h4
              class="text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200"
            >
              Lead'den Müşteri'ye dönüşen süre
            </h4>
            <p
              class="mt-2 sm:mt-3 text-4xl sm:text-6xl font-bold text-tile-600"
            >
              {{
                data.customer_average_conversion_time.average_conversion_time
              }}
              gün
            </p>
          </div>
          <!-- End Stats -->
        </div>
        <!-- End Grid -->
        <!-- End Features -->
      </div>
    </div>
  </div>
</template>

<script>
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import http from "../services/http";
export default {
  name: "adminPage",
  components: { adminSidebar: SidebarVue },
  data() {
    return {
      table: null,
      data: {
        users: { count: 0 },
        leads: { count: 0 },
        customers: { count: 0 },
        customer_average_conversion_time: { average_conversion_time: 0 }
      },
    };
  },
  mounted() {
    http.getAdminDashboard().then((e) => {
      this.data = e.data;
    });
  },
};
</script>
